import { mapState, mapActions } from 'vuex'

export default {
    created () {
        if (typeof this.epicIndex !== 'number' || typeof this.storyIndex !== 'number') {
            throw new Error('user-stories/state-mapper expects an "epicIndex" and "storyIndex" property for updates')
        }
    },
    
    computed: {

        stateTitle: {
            get () {
                return this._story().title
            },

            set (value) {
                this.setUserStoryProperty({ property: this._prefixProperty('title'), value })
            }
        },
        
        stateDescription: {
            get () {
                return this._story().description
            },

            set (value) {
                this.setUserStoryProperty({ property: this._prefixProperty('description'), value })
            }
        },

        stateTechNotes: {
            get () {
                return this._story().tech_notes
            },

            set (value) {
                this.setUserStoryProperty({ property: this._prefixProperty('tech_notes'), value })
            }
        },

        stateTestNotes: {
            get () {
                return this._story().test_notes
            },

            set (value) {
                this.setUserStoryProperty({ property: this._prefixProperty('test_notes'), value })
            }
        },
        
        stateComplexity: {
            get () {
                return this._story().complexity
            },

            set (value) {
                this.setUserStoryProperty({ property: this._prefixProperty('complexity'), value })
            }
        },
        
        stateEstimate: {
            get () {
                return this._story().estimate
            },

            set (value) {
                this.setUserStoryProperty({ property: this._prefixProperty('estimate'), value })
            }
        },

        stateDisplay: {
            get () {
                return this._story().display
            },

            set (value) {
                this.setUserStoryProperty({ property: this._prefixProperty('display'), value })
            }
        },
        
        stateAdjustedEstimate: {
            get () {
                return this._story().adjusted_estimate
            },

            set (value) {
                this.setUserStoryProperty({ property: this._prefixProperty('adjusted_estimate'), value })
            }
        },
        
        stateGroupId: {
            get () {
                return this._story().group_id
            },

            set (value) {
                this.setUserStoryProperty({ property: this._prefixProperty('group_id'), value })
            }
        },

        stateGroup: {
            get () {
                return this._story().group
            },

            set (value) {
                this.setUserStoryProperty({ property: this._prefixProperty('group'), value })
            }
        },

        stateTags: {
            get () {
                return this._story().tags
            },

            set (value) {
                this.setUserStoryProperty({ property: this._prefixProperty('tags'), value })
            }
        },

        stateRecording: {
            get () {
                return this._story().recording
            },

            set (value) {
                this.setUserStoryProperty({ property: this._prefixProperty('recording'), value })
            }
        },
    },

    methods: {
        ...mapActions('epics', ['setUserStoryProperty']),

        _prefixProperty (property) {
            return `epics.${this.epicIndex}.stories.${this.storyIndex}.${property}`
        },

        _story () {
            return this.epics[this.epicIndex].stories[this.storyIndex]
        }
    }
}
